import React from "react";
import { Button } from "@/components/ui/button";
import { Edit, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MessageStaffButton } from "./MessageStaffButton";

interface ActionsCellProps {
  userId: string;
  onDelete: (id: string) => void;
  isStaffAppUser?: boolean;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({
  userId,
  onDelete,
  isStaffAppUser = true,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center gap-1">
      <MessageStaffButton userId={userId} />
      {isStaffAppUser && (
        <>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => navigate(`/staff/${userId}`)}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onDelete(userId)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </>
      )}
    </div>
  );
};
